import { useEffect, useCallback } from 'react';
import {
  useFieldsChangedContext,
  useSetFieldsChangedContext
} from '../contexts/ContextProvider';

export default function useFieldsChangedMonitor({
  processingChange,
  detailedQCChange,
  geospatialQCChange,
  reasonablenessQCChange,
  initialQCChange,
  initialAnalystChange,
  finalQCChange
}) {
  const fieldsChanged = useFieldsChangedContext();
  const setFields = useSetFieldsChangedContext();

  const setFieldsChanged = useCallback(
    (field, value) => {
      setFields((curr) => ({ ...curr, [field]: value }));
    },
    [setFields]
  );

  //These keys must match the keys set in config.index.fieldsChangedInit
  const {
    processing,
    detailedQC,
    geospatialQC,
    reasonablenessQC,
    initialQC,
    initialAnalyst,
    finalQC
  } = fieldsChanged;

  useEffect(() => {
    if (processing !== processingChange) {
      setFieldsChanged('processing', processingChange);
    }
  }, [processing, processingChange, setFieldsChanged]);

  useEffect(() => {
    if (detailedQC !== detailedQCChange) {
      setFieldsChanged('detailedQC', detailedQCChange);
    }
  }, [detailedQC, detailedQCChange, setFieldsChanged]);

  useEffect(() => {
    if (geospatialQC !== geospatialQCChange) {
      setFieldsChanged('geospatialQC', geospatialQCChange);
    }
  }, [geospatialQC, geospatialQCChange, setFieldsChanged]);

  useEffect(() => {
    if (reasonablenessQC !== reasonablenessQCChange) {
      setFieldsChanged('reasonablenessQC', reasonablenessQCChange);
    }
  }, [reasonablenessQC, reasonablenessQCChange, setFieldsChanged]);

  useEffect(() => {
    if (initialQC !== initialQCChange) {
      setFieldsChanged('initialQC', initialQCChange);
    }
  }, [initialQC, initialQCChange, setFieldsChanged]);

  useEffect(() => {
    if (initialAnalyst !== initialAnalystChange) {
      setFieldsChanged('initialAnalyst', initialAnalystChange);
    }
  }, [initialAnalyst, initialAnalystChange, setFieldsChanged]);

  useEffect(() => {
    if (finalQC !== finalQCChange) {
      setFieldsChanged('finalQC', finalQCChange);
    }
  }, [finalQC, finalQCChange, setFieldsChanged]);
}
